import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useEffect, useState } from "react";
import { handleUpdateCompany } from "../../../api/companies";
import getBase64 from "../../../utils/getBase64";
import { CheckCircleFilled, DeleteOutlined } from "@ant-design/icons";

export default function UpdateCompany({
  isVisible,
  setVisible,
  selected,
}: any) {
  const { _id } = selected;
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState(null);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateCompany,
    onSuccess: () => {
      message.success("Updated Successfully");
      clearImage();
      queryClient.invalidateQueries({ queryKey: ["companies"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();

    let base64,
      type,
      size = null;

    if (selectedFile) {
      base64 = await getBase64(selectedFile);
      type = selectedFile?.type?.slice(selectedFile?.type - 3);
      size = selectedFile?.size;
    }
    const data = {
      ...values,
      logo: base64,
    };
    await mutate({ data, _id });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const clearImage = async () => {
    form.resetFields();
    form.setFieldsValue({ file: null });
    setSelectedFile(null);
    setIsSelected(false);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ name: selected?.name });
    form.setFieldsValue({ code: selected?.code });
    form.setFieldsValue({ min: selected?.min });
    form.setFieldsValue({ max: selected?.max });
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Update Company"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateCompany"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateCompany"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="code"
              label="Company Number"
              rules={[
                {
                  required: true,
                  message: "Please enter company number",
                },
              ]}
            >
              <Input type="text" placeholder="Company Number" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter company name",
                },
              ]}
            >
              <Input type="text" placeholder="Company Name" />
            </Form.Item>
          </Col>
        </Row>
        <div className="flex flex-col justify-center items-center bg-gray-100 h-32 rounded-md border">
          <div className="flex flex-col justify-center items-center">
            {isSelected ? (
              <div className="flex flex-col justify-center items-center">
                <CheckCircleFilled color={"#16a34a"} size={30} />
                <div className="text-gray-600 mt-2">Image Selected</div>
                <div className="text-gray-500">{selectedFile?.name}</div>
                <button
                  className="text-red-200 flex items-center hover:text-red-500"
                  onClick={() => clearImage()}
                >
                  <DeleteOutlined /> <span className="mx-1">Remove</span>
                </button>
              </div>
            ) : (
              <Form.Item
                name="file"
                label="Upload Logo ( Optional )"
                rules={[
                  {
                    required: false,
                    message: "Please select file",
                  },
                ]}
              >
                <Input
                  type="file"
                  placeholder="Image"
                  onChange={changeHandler}
                />
              </Form.Item>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
}
